import {Injectable} from "@angular/core";
import {Graph, IConnectorsEdges, IDimensions, IGraphData, Layout, TGraphType} from "../models/graph-kn.model-interfaces";
import {GraphKnDataService} from "./graph-kn.data.service";
import {Layer} from "konva/lib/Layer";
import {Vector2d} from "konva/lib/types";
import {Line} from "konva/lib/shapes/Line";
import {GraphKnConnectorsLayersService} from "./graph-kn.connectros-layers.service";
import {BUSINESS_PROCESS_LAYER_ID, DagreNodesOnlySettings} from "../models/graph-kn.cm-api-models";
import {ARROW_POINTER_RADIUS, MIN_ARROW_LENGTH} from "../models/graph-kn.cm.arrows-model-const";
import {
    CONTRACT_BP_RATIO_HEIGHT,
    CONTRACT_BP_RATIO_WIDTH,
    CONTRACT_TASK_RATIO_HEIGHT
} from "../models/graph-kn.cm.model-const";
import { IXYNode, XYEdgeService } from "./xyflow-edge.service";
import { Group } from "konva/lib/Group";
import { Path } from "konva/lib/shapes/Path";
import { Circle } from "konva/lib/shapes/Circle";
import { Rect } from "konva/lib/shapes/Rect";
import { Arrow } from "konva/lib/shapes/Arrow";
import { EdgePointerType, EEdgyType, ELayoutAlgorithms, Position } from "../models/graph-kn.model-enums";
import { ElkLayoutService } from "./layout/elk-layout.service";
import { map, Observable, of, tap } from "rxjs";
import { IEdgePointersData } from "../models/xyflow.models";
import { RectModelsMap } from "../styles/graph-node-rect-model";
@Injectable({
    providedIn: 'root'
})
export class LayOutService {
	constructor(
			private knDataService: GraphKnDataService,
			private knConnectorsService: GraphKnConnectorsLayersService,
			private xyEdgeService: XYEdgeService,
			private elkLayoutService: ElkLayoutService,
	) {
	}

	calculateLayoutPostionDagre(data: IGraphData, layout: Layout): Graph {
			let graphData = {
					edgeLabels: [],
					...data
			}
			let res = layout.run(graphData as unknown as Graph)  as Graph;
			res.rankCount = new Set(res.nodes.map(el => (el.position?.x || 0))).size
			res.rowCount = new Set(res.nodes.map(el => (el.position?.y || 0))).size
			return (res as Graph)
	}

	prepareLayoutInit(businessProcessGD: IGraphData, layoutDagre: Layout, layerDims: IDimensions):Observable<boolean> {
		let settings = this.knDataService.layoutDagreSettings.get(BUSINESS_PROCESS_LAYER_ID)
		let BP_Task_Ration_Height = this.knDataService.layersMap.size === 1 ? CONTRACT_BP_RATIO_HEIGHT : CONTRACT_TASK_RATIO_HEIGHT
		let parent = this.knDataService.layoutDagreSettings.get(BUSINESS_PROCESS_LAYER_ID)?.parent
		switch (settings?.module) {
			case ELayoutAlgorithms.Darge:
				return this.prepareLayoutDagre(businessProcessGD, layoutDagre, layerDims,BP_Task_Ration_Height)
			case ELayoutAlgorithms.ELK:
				return parent? this.prepareLayoutELK_BP_Links(businessProcessGD) : this.prepareLayoutELK(businessProcessGD)
			default:
				return of(false)
		}
	}
	prepareLayoutELK_BP_Links(businessProcessGD: IGraphData) :Observable<boolean> {
    let rectModel = RectModelsMap.get('BPStatus')
		return this.elkLayoutService.createElkLayout_BP_Links(businessProcessGD).pipe(
			tap(positions=>{
                this.knDataService.nodeWidth = rectModel!.width!
                this.knDataService.nodeHeight = rectModel!.height!
                
                if (positions.children) {
                    positions.children.forEach(bpGroup => {
                        let bpNode = businessProcessGD.nodes.find(el => el.id === bpGroup.id)
                        if (bpNode) {
                            bpNode.position = {x:(bpGroup.x||0),y:(bpGroup.y)||0};
                            bpNode.dimension = {
                                width:(bpGroup.width||this.knDataService.nodeWidth),
                                height:(bpGroup.height || this.knDataService.nodeHeight)
                            }
                        } 

                        bpGroup.children?.forEach(bpStatus=>{
                            let bpNode = businessProcessGD.nodes.find(el => el.id === bpStatus.id)
                            bpNode?.position?  bpNode.position = {
                                x:(bpGroup.x||0) + (bpStatus.x ||0),
                                y:(bpGroup.y||0) + (bpStatus.y ||0)
                            } : null;
                            bpNode?.dimension? bpNode.dimension = {
                                width:(bpStatus.width||this.knDataService.nodeWidth),
                                height:(bpStatus.height || this.knDataService.nodeHeight)
                            }: null;
                        })
                    })
                }
                
                businessProcessGD.edges.forEach(edge =>{
                    let edgeData = positions.edges?.find(el=>el.id === edge.id)
                    let sections = edgeData?.sections
                    edge.points_labels = [];
                    sections? edge.points_labels.push (sections[0].startPoint) : null;
                    sections && sections[0].bendPoints? edge.points_labels.push(...sections[0].bendPoints) : null;
                    sections? edge.points_labels.push (sections[0].endPoint) : null;
                    edge.points = edge.points_labels
                })
            }),
			map(()=>true)
		)
	}
	prepareLayoutELK(businessProcessGD: IGraphData) :Observable<boolean> {
		return this.elkLayoutService.createElkLayout(businessProcessGD).pipe(
			tap(positions=>{
				if (positions.children) {
					positions.children.forEach(node => {
						let gdNode = 	businessProcessGD.nodes.find(el => el.id === node.id)
						gdNode?.position?  gdNode.position = {x:(node.x||0),y:(node.y)||0} : null;
					})
				}
				businessProcessGD.edges.forEach(edge =>{
					let edgeData = positions.edges?.find(el=>el.id === edge.id)
					let sections = edgeData?.sections
					edge.points_labels = [];
					sections? edge.points_labels.push (sections[0].startPoint) : null;
					sections && sections[0].bendPoints? edge.points_labels.push(...sections[0].bendPoints) : null;
					sections? edge.points_labels.push (sections[0].endPoint) : null;
					edge.points = edge.points_labels
				})
			}),
			map(()=>true)
		)
	}
	prepareLayoutDagre(
        businessProcessGD: IGraphData, layoutDagre: Layout, 
        layerDims: IDimensions,BP_Task_Ration_Height:number
    ):Observable<boolean> {
        let rectModel = RectModelsMap.get('BPStatus')! 
		let positions = this.calculateLayoutPostionDagre(businessProcessGD, layoutDagre)
		let rankCount = positions.rankCount || 1;
		let layerWidth = layerDims.width
		let layerHeight = layerDims.height;
		let rowCount = positions.rankCount || 1;
        if (this.knDataService.layoutDagreSettings.get('bpLayer')?.nodeWidthAdaptive) {
            this.knDataService.nodeWidth = layerWidth ? Math.min((layerWidth - (rankCount + 1) * MIN_ARROW_LENGTH) / rankCount, rectModel.width!) : rectModel.width!
        } else {
            this.knDataService.nodeWidth = rectModel.width! * CONTRACT_BP_RATIO_WIDTH
        }
        this.knDataService.nodeHeight = Math.min((layerHeight) / (rowCount - 1), rectModel.height!) * BP_Task_Ration_Height
        businessProcessGD.nodes.forEach(node => node.dimension! = {
        width: this.knDataService.nodeWidth,
        height: this.knDataService.nodeHeight
        });
		positions = this.calculateLayoutPostionDagre(businessProcessGD, layoutDagre)
    
		positions.nodes.forEach(node => businessProcessGD.nodes.find(el => el.id === node.id)!.position! = {
            x: node.position!.x - node.dimension!.width/2,
            y:node.position!.y - node.dimension!.height/2
        })
		businessProcessGD.edges.forEach(edge =>{
			edge.points_labels =  positions.edgeLabels![edge.source + '\u0001' + edge.target + '\u0001' + edge.id]?.points || edge.points
		})
		return of(true)
	}
	updateGraph(connectorsEdges: IConnectorsEdges[], graphLayer: Layer, movement: Vector2d = {x: 0,y: 0	},targetID: string = '',nodeGroup?:Group, layerId?:TGraphType
	) {
    
		let graphSettings = this.knDataService.layoutDagreSettings.get(layerId||BUSINESS_PROCESS_LAYER_ID)
		this.knDataService.linkEdge?.attrs.points ? this.getLinkToActiveStepPoints(movement, targetID) : null
		this.knConnectorsService.adjustContractConnector(targetID, movement)
		connectorsEdges.forEach((connector) => {
			if (connector.from === nodeGroup?.attrs.id || connector.to === nodeGroup?.attrs.id) {
				let fromNode = graphLayer.findOne('#' + connector.from) as Group;
				let toNode = graphLayer.findOne('#' + connector.to) as Group;
				let edgePath = graphLayer.findOne('#' + connector.id + '_edge_path') as Path|Line
				let edgePointer = graphLayer.findOne('#' + connector.id + '_edge_pointer') as Circle|Rect|Arrow
				switch (graphSettings?.algorithmEdges) {
					case ELayoutAlgorithms.Darge:
						this.updateDagreEdgesXY(edgePath, edgePointer,nodeGroup,connector,fromNode, toNode )
						//this.updateDagreEdges(edgePath, edgePointer, nodeGroup, connector)
						//this.updateDagreEdgesNew(edgePath, edgePointer, nodeGroup, connector)
					break;
					case ELayoutAlgorithms.ELK:
						this.updateDagreEdges(edgePath, edgePointer,nodeGroup,connector)
						//this.updateDagreEdgesXY(edgePath, edgePointer, nodeGroup, connector, fromNode, toNode)
					break;
					case ELayoutAlgorithms.Local:
						edgePath? this.updateLocalEdges(fromNode, toNode, connector, edgePath as Path, edgePointer, graphSettings) : null
					break;
				};
			}
		});
	}
	
	updateLocalEdges(fromNode:Group,toNode:Group,connector:IConnectorsEdges, edgePath:Path, edgePointer:Rect|Circle|Arrow,settings:DagreNodesOnlySettings){
    let rectModel = RectModelsMap.get('BPStatus')
    let toPos:Vector2d  = {
			x:toNode.x() + (connector.toRelativePos?.x||0),
			y:toNode.y() + (connector.toRelativePos?.y||0)
		}
		if (fromNode && toNode){ 
			let source:IXYNode = {
				x:fromNode.attrs.x,
				y:fromNode.attrs.y,
				id:fromNode.attrs.id,
                width:rectModel?.width!,
                height:rectModel?.width!,
			}
			let target:IXYNode = {
				x:toNode.attrs.x,
				y:toNode.attrs.y,
				id:toNode.attrs.id,
                width:rectModel?.width!,
                height:rectModel?.width!,
			} 
			let newEdgeGroup =this.xyEdgeService.prepareXYEdge(source,target,connector.id,settings.edgeType,settings.pointerType,undefined,connector)
			newEdgeGroup.path? edgePath.data(newEdgeGroup.path.data()) : null;
            if (settings.pointerType === EdgePointerType.Arrow && newEdgeGroup.path) {
                let arrowPointer = edgePointer as Arrow
                let pathForPointer =newEdgeGroup.path
                let pathLen = pathForPointer.getLength()
                let pointerBend = pathForPointer.getPointAtLength(pathLen-15)
                let pointerPoints = [pointerBend?.x||0,pointerBend?.y||0, toPos.x, toPos.y]
                arrowPointer?.points(pointerPoints);
            } else {
                newEdgeGroup.pointer? edgePointer.position(newEdgeGroup.pointer.position()) : null;
            }
		}  
	}

	updateDagreEdgesXY(edgePath:Path|Line, edgePointer:Rect|Circle|Arrow,group:Group,connector:IConnectorsEdges, fromNode:Group, toNode:Group ) {
		let edge = edgePath as Arrow;
		let pointer = edgePointer;
		let toPos:Vector2d  
		let fromPos:Vector2d
		toPos = {
			x:toNode.x() + (connector.toRelativePos?.x||0),
			y:toNode.y() + (connector.toRelativePos?.y||0)
		}
		fromPos = {
			x:fromNode.x() + (connector.fromRelativePos?.x||0),
			y:fromNode.y() + (connector.fromRelativePos?.y||0)
		}
		let edgePointData: IEdgePointersData = {
				pointFrom:fromPos||{x:0,y:0},
				pointFromPosition:connector.fromEdgePos||Position.Top,
				pointTo:toPos,
				pointToPosition:connector.toEdgePos||Position.Left
		}
		let pathData  =this.xyEdgeService.calcEdgeXYPath(edgePointData,EEdgyType.Bezier)
 		edge.points(pathData.points)
    let arrowPointer = pointer as Arrow
    let circlePointer = pointer as Circle
    let pointerPositions:Vector2d = toPos
		let pointerPoints:number[] = [];
		let pathForPointer = new Path({
			data:pathData.path,
			x:0,
			y:0
		})
		let pathLen = pathForPointer.getLength()
		let pointerBend = pathForPointer.getPointAtLength(pathLen-30)

		if (pathData.points) {
			pointerPoints = [pointerBend?.x||0,pointerBend?.y||0, toPos.x, toPos.y]
		}
   arrowPointer?.name()==='Arrow'? arrowPointer?.points(pointerPoints) : circlePointer.position(pointerPositions)
	}

	updateDagreEdges(edgePath:Path|Line, edgePointer:Rect|Circle|Arrow,group:Group,connector:IConnectorsEdges) {
		let edge = edgePath as Line;
		let pointer = edgePointer;
		let points = edge.points()
		let len = points.length
		let dx = 0;
		let dy = 0;
		if (group.attrs.id === connector.to) {
			dx = points [len-2] - (group.x() + (connector.toRelativePos?.x||0))
			dy = points [len-1] - (group.y()  + (connector.toRelativePos?.y||0))
			points [len-2] = group.x() + (connector.toRelativePos?.x || 0) 
			points [len-1] = group.y()  + (connector.toRelativePos?.y||0)
		} else{
			dx = points [0] - (group.x() + (connector.fromRelativePos?.x||0))
			dy = points [1] - (group.y()  + (connector.fromRelativePos?.y||0))
			points [0] = group.x() + (connector.fromRelativePos?.x||0) 
			points [1] = group.y()  + (connector.fromRelativePos?.y||0)
		}
    
		for (let i = 2; i < points.length - 2; i += 1) {
			points[i] += i%2 === 0? -dx  : -dy;
		}

 		edge.points(points)
    let arrowPointer = pointer as Arrow
    let circlePointer = pointer as Circle
    let pointerPositions:Vector2d = {
      x:(points.at(-2)||1),
      y:points.at(-1)||1
    }
    arrowPointer?.name()==='Arrow'? arrowPointer?.points(points) : circlePointer.position(pointerPositions)

	}
	updateDagreEdgesNew(edgePath:Path|Line, edgePointer:EdgePointerType,group:Group,connector:IConnectorsEdges) {
		let edge = edgePath as Line;
		let pointer = edgePointer;
		let points = edge.points()
    let pointsRelative = connector.relativePointsData||[]
		let len = points.length
		let dx = 0;
		let dy = 0;
		if (group.attrs.id === connector.to) {
			dx = points [len-2] - (group.x() + (connector.toRelativePos?.x||0))
			dy = points [len-1] - (group.y()  + (connector.toRelativePos?.y||0))
			points [len-2] = group.x() + (connector.toRelativePos?.x||0) - ARROW_POINTER_RADIUS
			points [len-1] = group.y()  + (connector.toRelativePos?.y || 0)
		} else{
			dx = points [0] - (group.x() + (connector.toRelativePos?.x||0))
			dy = points [1] - (group.y()  + (connector.fromRelativePos?.y||0) )
			points [0] = group.x() + (connector.toRelativePos?.x||0) - ARROW_POINTER_RADIUS
			points [1] = group.y()  + (connector.fromRelativePos?.y||0)
		}
    let lenX =  (points.at(-2)||0) - points[0]
    let lenY =  (points.at(-1)||0) - points[1]
    
		for (let i = 2; i < points.length - 3; i += 1) {
			points[i] += i%2 === 0? 0  : -dy;
		  i%2 === 0? points[i] = lenX * pointsRelative[i] + points[0]  : null;
      //temp
		  //i%2 === 0? points[i] = lenX * pointsRelative[i] + points[0]  : points[i] = lenY * pointsRelative[i]+ points[1];
		}
 		edge.points(points)
    let arrowPointer = pointer as unknown as Arrow
    let circlePointer = pointer as unknown as Circle
    let pointerPositions:Vector2d = {
      x:(points.at(-2)||1),
      y:points.at(-1)||1
    }
    arrowPointer?.name()==='Arrow'? arrowPointer?.points(points) : circlePointer.position(pointerPositions)
	}
	getDagreConnectorEdgesPoints(connector: IConnectorsEdges, linePoints: number[], movement: Vector2d, targetID: string = ''): number[] {
			if (connector.from === targetID) {
					linePoints[0] += movement.x;
					linePoints[1] += movement.y;
			}
			if (connector.to === targetID) {
					linePoints[linePoints.length - 2] += movement.x;
					linePoints[linePoints.length - 1] += movement.y;
			}
			if ([connector.to, connector.from].includes(targetID)) {
					for (let i = 2; i < linePoints.length - 2; i += 2) {
							if (connector.moveAlg === 'calc') {
									linePoints[i] = Math.min(linePoints[0], linePoints[linePoints.length - 2]) + Math.abs(linePoints[linePoints.length - 2] - linePoints[0]) * 0.75;
									linePoints[i + 1] = Math.min(linePoints[1], linePoints[linePoints.length - 1]) + Math.abs(linePoints[linePoints.length - 1] - linePoints[1]) / 2;
							} else {
									linePoints[i] += movement.x;
									linePoints[i + 1] += movement.y;
							}
					}
			}
			return [...linePoints]
	}

	getLinkToActiveStepPoints(movement: Vector2d, targetID: string = '') {
			let points = [...this.knDataService.linkEdge.attrs.points]
			if (this.knDataService.linkEdge.attrs.from === targetID) {
					points[0] += movement.x;
					points[1] += movement.y;
					points[2] += movement.x;
					points[3] += movement.y;
			}
			if (this.knDataService.linkEdge.attrs.to === targetID) {
					points[points.length - 2] += movement.x;
					points[points.length - 1] += movement.y;
			}
			this.knDataService.linkEdge.points(points)
	}
}